<div class="tw-flex tw-justify-between">
    <h1 mat-dialog-title>
        {{ 'ADDONS.REGISTER_ORGANIZATION_DIALOG.TITLE' | translate }}
    </h1>
</div>
<mat-dialog-content>
    <p>{{ 'ADDONS.REGISTER_ORGANIZATION_DIALOG.DESCRIPTION' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="tw-flex tw-gap-2">
        <button
            mat-raised-button
            (click)="cancel()">
            {{ 'ADDONS.REGISTER_ORGANIZATION_DIALOG.CANCEL' | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="register()">
            {{ 'ADDONS.REGISTER_ORGANIZATION_DIALOG.REGISTER' | translate }}
        </button>
    </div>
</mat-dialog-actions>
